import React from 'react';

import * as styles from './styles.css';

const AccessibilityText: React.FC = ({ children }) => {
  return <span className={styles['screen-reader-only']}>{children}</span>;
};

export default AccessibilityText;
